import { fmtDate } from '../lib/format';
import type { Verlauf } from './types';

// Preis-Empfehlung aus den eigenen alten Rechnungen (ohne KI): Was wurde zuletzt an diesem Einsatzort, an dieser
// Anschrift oder für diesen Kunden berechnet? Neueste Rechnung zuerst.

export interface Empfehlung {
  from: Verlauf;
  // woran erkannt: Einsatzort, Anschrift des Kunden oder nur der Kunde
  by: 'objekt' | 'adresse' | 'kunde';
  text: string;
}

// „Am Sandtorkai 5“, „am sandtorkai 5 “ und „Sandtorkai-Straße“/„Sandtorkaistr.“ gleich behandeln
export const norm = (s: string | null | undefined) =>
  (s ?? '')
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .replace(/strasse\b/g, 'str')
    .replace(/str\./g, 'str')
    .replace(/[^a-z0-9äöü]/g, '');

// Gleich, wenn ein Teil (durch Komma getrennt) übereinstimmt: „Kehrwieder 7“ passt zu „Lagerhalle 3, Kehrwieder 7“,
// „Ring 2“ aber nicht zu „Ring 21“
const parts = (s: string | null | undefined) =>
  (s ?? '')
    .split(/[,;\n]/)
    .map(norm)
    .filter((p) => p.length >= 4);
const same = (a: string | null | undefined, b: string | null | undefined) => {
  const pb = parts(b);
  return parts(a).some((p) => pb.includes(p));
};

export const isHourly = (unit: string) => /^(std|stunde|h$)/i.test(unit.trim());

export function empfehlung(verlauf: Verlauf[], c: { name: string; street: string; site: string }): Empfehlung | null {
  const site = norm(c.site);
  const name = norm(c.name);
  const ref = (v: Verlauf) => `${v.number} vom ${fmtDate(v.invoiceDate)}`;
  if (site) {
    // dasselbe Objekt: früher als Einsatzort angegeben oder dort die Rechnungsanschrift (ohne eigenen Einsatzort)
    const v = verlauf.find((x) => same(c.site, x.site) || (!x.site && same(c.site, x.street)));
    if (v) return { from: v, by: 'objekt', text: `Zuletzt an diesem Einsatzort (${ref(v)})` };
  } else {
    const v = verlauf.find((x) => (!x.site && same(c.street, x.street)) || same(c.street, x.site));
    if (v) return { from: v, by: 'adresse', text: `Zuletzt bei ${c.street.trim()} (${ref(v)})` };
  }
  if (name.length >= 3) {
    const v = verlauf.find((x) => norm(x.customer) === name);
    if (v) return { from: v, by: 'kunde', text: `Zuletzt bei ${v.customer} (${ref(v)})` };
  }
  return null;
}
